import { UserEventFilterType } from '../enums/user-event-filter-type.enum';
import { UserEventType } from '../enums/user-event-type.enum';

export const USER_EVENT_BUSINESS_LABEL_MAP: Partial<
  Record<keyof typeof UserEventType, UserEventFilterType>
> = {
  ZALOZENIE_KONTA: UserEventFilterType.UTWORZENIE_KONTA,
  ZAPIS_ZMIENIONYCH_DANYCH_SWOJEGO_KONTA:
    UserEventFilterType.MODYFIKACJA_DANYCH,
  ZAPIS_ZMIENIONYCH_DANYCH_CZLONKA_RODZINY:
    UserEventFilterType.MODYFIKACJA_DANYCH,
  AKTUALIZACJA_DANYCH_ORGANIZACJI:
    UserEventFilterType.MODYFIKACJA_DANYCH,
  ZALOGOWANIE_DO_SYSTEMU: UserEventFilterType.ZALOGOWANIE,
  WYLOGOWANIE_UZYTKOWNIKA_Z_SYSTEMU: UserEventFilterType.WYLOGOWANIE,
  ZABLOKOWANIE_UZYTKOWNIKA:
    UserEventFilterType.ZABLOKOWANIE_UZYTKOWNIKA,
  ODBLOKOWANIE_UZYTKOWNIKA:
    UserEventFilterType.ODBLOKOWANIE_UZYTKOWNIKA,
  NADANIE_PRAWA_ADMINA: UserEventFilterType.NADANIE_PRAWA_ADMINA,
  ODEBRANIE_PRAWA_ADMINA: UserEventFilterType.ODEBRANIE_PRAWA_ADMINA,
  AKCEPTACJA_REGULAMINU: UserEventFilterType.ZATWIERDZENIE_REGULAMINU,
  DODANIE_DO_ORGANIZACJI: UserEventFilterType.DODANIE_DO_ORGANIZACJI,
  ZMIANA_WLASCICIELA_ORGANIZACJI: UserEventFilterType.PRZEJECIE_ORGANIZACJI,
  PRZEJECIE_INSTYTUCJI_ORGANIZACJI: UserEventFilterType.PRZEJECIE_INSTYTUCJI_ORGANIZACJI,
  USUNIECIE_REPREZENTANTA_ORGANIZACJI:
    UserEventFilterType.USUNIECIE_Z_ORGANIZACJI,
  ZAPIS_PELNOMOCNICTWA_REPREZENTANTA:
    UserEventFilterType.DODANIE_UPRAWNIEN_W_ORGANIZACJI,
  USUNIECIE_PELNOMOCNICTWA_REPREZENTANTA:
    UserEventFilterType.USUNIECIE_UPRAWNIEN_W_ORGANIZACJI,
  ZMIANA_ROLI_REPREZENTANTA_ORGANIZACJI:
    UserEventFilterType.MODYFIKACJA_UPRAWNIEN_W_ORGANIZACJI,
  DODANIE_NOWEGO_CZLONKA_RODZINY:
    UserEventFilterType.DODANIE_CZLONKA_RODZINY,
  USUNIECIE_CZLONKA_RODZINY:
    UserEventFilterType.USUNIECIE_CZLONKA_RODZINY,
  WYSLANIE_DOKUMENTU: UserEventFilterType.WYSLANIE_WNIOSKU,
  ZAPIS_ZMODYFIKOWANEGO_DOKUMENTU_ROBOCZEGO:
    UserEventFilterType.ZAPIS_ZMODYFIKOWANEGO_DOKUMENTU_ROBOCZEGO,
  USUNIECIE_DOKUMENTU_ROBOCZEGO:
    UserEventFilterType.REZYGNACJA_Z_WNIOSKU,
  WYSLANIE_ZAPROSZENIA_DO_ORGANIZACJI:
    UserEventFilterType.ZAPROSZENIE_DO_ZARZADZANIA_ORGANIZACJA,
  PRZYJECIE_ZAPROSZENIA_DO_ORGANIZACJI:
    UserEventFilterType.PRZYJECIE_ZAPROSZENIA_DO_ZARZADZANIA_ORGANIZACJA,
  BRAK_POTWIERDZENIA_W_TERMINIE_ZAPROSZENIA_DO_ORGANIZACJI:
    UserEventFilterType.BRAK_POTWIERDZENIA_W_TERMINIE_ZAPROSZENIA_DO_ZARZADZANIA_ORGANIZACJA,
  UTWORZENIE_NOWEGO_DOKUMENTU:
    UserEventFilterType.AKTUALIZACJA_DANYCH_W_KREATORZE,
  WYZNACZENIE_ADRESATA_DOKUMENTU:
    UserEventFilterType.AKTUALIZACJA_DANYCH_W_KREATORZE,
  DODANIE_ZALACZNIKA_DO_DOKUMENTU:
    UserEventFilterType.AKTUALIZACJA_DANYCH_W_KREATORZE,
  USUNIECIE_ZALACZNIKA_DO_DOKUMENTU:
    UserEventFilterType.AKTUALIZACJA_DANYCH_W_KREATORZE,
  ZAPIS_ZMODYFIKOWANEGO_ZALACZNIKA_DO_DOKUMENTU:
    UserEventFilterType.AKTUALIZACJA_DANYCH_W_KREATORZE,
  WYBOR_METODY_DOSTARCZENIA_DOKUMENTU_ZWROTNEGO:
    UserEventFilterType.AKTUALIZACJA_DANYCH_W_KREATORZE,
  PROBA_WYSZUKANIA_UZYTKOWNIKA:
    UserEventFilterType.PROBA_WYSZUKANIA_UZYTKOWNIKA,
};

export function getUserEventBusinessLabel(
  eventType: keyof typeof UserEventType,
): string {
  return USER_EVENT_BUSINESS_LABEL_MAP[eventType] ?? UserEventType[eventType];
}
